import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: 'h-6 w-6',
};

const RunIcon = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <path
            d="M13.49 5.50098C14.59 5.50098 15.49 4.60098 15.49 3.50098C15.49 2.40098 14.59 1.50098 13.49 1.50098C12.39 1.50098 11.49 2.40098 11.49 3.50098C11.49 4.60098 12.39 5.50098 13.49 5.50098ZM10.32 17.501L10.89 15.001L12.99 17.001V22.001C12.99 22.551 13.44 23.001 13.99 23.001C14.54 23.001 14.99 22.551 14.99 22.001V16.361C14.99 15.811 14.77 15.291 14.37 14.911L12.89 13.501L13.49 10.501C14.56 11.741 16.11 12.631 17.85 12.911C18.45 13.001 18.99 12.521 18.99 11.911C18.99 11.421 18.63 11.011 18.14 10.931C16.62 10.681 15.36 9.78098 14.69 8.60098L13.69 7.00098C13.29 6.40098 12.69 6.00098 11.99 6.00098C11.69 6.00098 11.49 6.10098 11.19 6.10098L7.21004 7.78098C6.47004 8.10098 5.99004 8.82098 5.99004 9.63098V12.001C5.99004 12.551 6.44004 13.001 6.99004 13.001C7.54004 13.001 7.99004 12.551 7.99004 12.001V9.60098L9.79004 8.90098L8.19004 17.001L4.27004 16.201C3.73004 16.091 3.20004 16.441 3.09004 16.981V17.021C2.98004 17.561 3.33004 18.091 3.87004 18.201L7.98004 19.021C9.04004 19.231 10.08 18.561 10.32 17.501Z"
            fill="currentColor"
        />
    </svg>
);

RunIcon.propTypes = propTypes;
RunIcon.defaultProps = defaultProps;

export default React.memo(RunIcon);
